const parsePayload = (payloadText: string) => {
  let payload: Record<string, string>
  try {
    payload = JSON.parse(payloadText)
  } catch (e) {
    return {}
  }
  return payload
}

export const getTypeAndPayloadFromEvent = (data: string) => {
  let type: string

  const index = data.indexOf('/') // Find the index of the first "/"
  let payload: Record<string, string>

  // Check if "/" exists in the string
  if (index !== -1) {
    type = data.slice(0, index) // Get the part before "/"
    const payloadText = data.slice(index + 1) // Get the part after "/"
    payload = parsePayload(payloadText)
  } else {
    type = data
    return { type }
  }
  return { type, payload }
}

export const checkResError = (res: Record<string, string>) => {
  return false
}

export const checkOldResError = (res: any) => {
  return false
}
